import { STATUS } from "@/constant/statusConstants";
import createLocalizationsSchema from "@/schema/WebDataManagement/MasterData/Localizations/createLocalizationsSchema";
import * as Yup from "yup";

const VideoCategorySchema = (localeCodes, isEdit = false) =>
  Yup.object().shape({
    status: Yup.string()
      .label("Status")
      .required()
      .oneOf(Object.values(STATUS)),
    localizations: createLocalizationsSchema(localeCodes),
  });

export default VideoCategorySchema;
